import { Box, Button } from '@mui/material';

/** This component is displayed as the main buttons at the top-most level of each scope after the user expands the dashboard accordion.
 * @param {Object} props Main categories to loop over. Selected category to compare against. Setter function to set category when the user clicks it.
 * @param {Array} props.mainCategories Main categories array.
 * @param {string} props.selectedCategory The currently selected main category.
 * @param {(selectedCategory: string) => void} props.setSelectedCategory A setter function given by useState that will update the selected category on click.
 * @returns {JSX.Element}
 */

export default function MainCategoryButtons({ mainCategories, selectedCategory, setSelectedCategory }) {

    return (
        <Box my={2} sx={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
            {mainCategories.map((category, index) => {
                return (
                    <Button
                        key={index}
                        variant={category === selectedCategory ? 'contained' : 'outlined'}
                        size='large'
                        sx={{ width: 'fit-content' }}
                        onClick={() => {
                            setSelectedCategory(category);
                        }}
                    >
                        {category}
                    </Button>
                )
            })
            }
        </Box>
    )

}